import type { EntryDateSelection } from '@libs/enums';
import { entryDateSelection } from '@libs/enums';
import { calculateEndingYearMonth } from './calcEndingYearMonth';

function calcSpecifyInputCondition(
  processingMonth: Date,
  beginningYearMonth: Date,
  specifySelectionCondition: EntryDateSelection,
) {
  switch (specifySelectionCondition) {
    case entryDateSelection.enum.currentMonth:
      return { from: processingMonth, to: processingMonth };
    case entryDateSelection.enum.currentPeriod: {
      const endingYearMonth = calculateEndingYearMonth(beginningYearMonth);
      return { from: beginningYearMonth, to: endingYearMonth };
    }
    case entryDateSelection.enum.upToCurrentMonth:
      return { from: beginningYearMonth, to: processingMonth };
  }
}

export { calcSpecifyInputCondition };
